import _extends from "@babel/runtime/helpers/extends";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import PropTypes from "prop-types";
import styles from "./ChildWarning.module.css";

const HsTreeChildWarning = _ref => {
  let {
    children,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React.createElement("li", _extends({
    className: styles.childWarning
  }, otherProps), children);
};

HsTreeChildWarning.propTypes = {
  children: PropTypes.node.isRequired
};

const _default = /*#__PURE__*/React.memo(HsTreeChildWarning);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(HsTreeChildWarning, "HsTreeChildWarning", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/HsCodesTree/ChildWarning/ChildWarning.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/HsCodesTree/ChildWarning/ChildWarning.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();